export default function imageLoader({ src, width, quality }) {
  return `https://cdn-crayo.com/lp/public/${src}`;
}
